export interface Automation {
  id: string;
  description: string;
  url: string;
  environment: 'production' | 'staging';
  created_at: any;
  updated_at: any;
}

export const defaultAutomations: Omit<Automation, 'created_at' | 'updated_at'>[] = [
  {
    id: 'irreplaceable',
    description: 'Typeform URL for Irreplaceable campaign',
    url: 'https://form.typeform.com/to/abcdefgh?planid=xxxxx',
    environment: 'production'
  },
  {
    id: 'evaluator-promo-code',
    description: 'Send promo code to evaluator',
    url: 'https://hook.us2.make.com/mnxrrx2molh0xi9vm43mkjf665pp4oh2',
    environment: 'production'
  },
  {
    id: 'send-verification-code',
    description: 'Send verification code for evaluator access',
    url: 'https://hook.us2.make.com/mnxrrx2molh0xi9vm43mkjf665pp4oh2',
    environment: 'production'
  },
  {
    id: 'new-user',
    description: 'Process new user registration',
    url: 'https://hook.us2.make.com/2x4598hee5ccqlvk4adhgfg51xbtqidn',
    environment: 'production'
  },
  {
    id: 'evaluator-nominated',
    description: 'Process new evaluator nomination',
    url: 'https://hook.us2.make.com/8x4598hee5ccqlvk4adhgfg51xbtqidn',
    environment: 'production'
  },
  {
    id: 'onboarding-form',
    description: 'Onboarding tutorial form',
    url: 'https://form.typeform.com/to/abcdefgh?subjectfirstname=xxxxx&userid=yyyyy',
    environment: 'production'
  }
];
